const LOCK_RETRY_DELAY = 100;
const LOCK_MAX_RETRIES = 200;

export async function acquireScoringLock (docRef, db, dbFns) {
  for (let attempt = 0; attempt < LOCK_MAX_RETRIES; attempt++) {
    try {
      await dbFns.runTransaction(db, async (transaction) => {
        const doc = await transaction.get(docRef);
        if (doc.data().scoringLock) {
          throw new Error("LOCK_HELD");
        }
        transaction.update(docRef, { scoringLock: true });
      });
      return;
    } catch (e) {
      if (e.message !== "LOCK_HELD") {
        throw e;
      }
      await new Promise(r => setTimeout(r, LOCK_RETRY_DELAY));
    }
  }
  throw new Error("Could not acquire scoring lock");
}
